import React from "react";
import Aboutus from "../Components/about/Aboutus";
import PageHeader from "../Components/common/PageHeader";
import { useTranslation } from "react-i18next";
import SEO from "../Components/common/SEO";
import Spacer2 from "../Components/common/Spacer2";

function AboutPage() {
  const { t } = useTranslation();
  const siteUrl = 'https://seymenkimya.com';
  const pageUrl = `${siteUrl}/kurumsal`;

  const orgStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Seymen Kimya',
    'url': siteUrl,
    'logo': `${siteUrl}/assets/images/favicons/favicon-32x32.webp`,
    'description': 'Kurumsal bilgiler ve profesyonel temizlik ürünleri hakkında bilgi.',
    'contactPoint': {
      '@type': 'ContactPoint',
      'telephone': '+90-224-360-1166',
      'contactType': 'customer service'
    }
  };

  return (
    <>
      <SEO
        title="Kurumsal | Seymen Kimya"
        description="Seymen Kimya kurumsal bilgiler, misyon ve vizyon."
        canonical={pageUrl}
        image={`${siteUrl}/assets/images/about/about.webp`}
        structuredData={orgStructuredData}
      />
      <PageHeader title={t("HAKKIMIZDA")} />
      <Aboutus />
    </>
  );
}

export default AboutPage;
